import type { BoxAccessPolicy } from '@deepcloud/api-deep-box'

export function useBoxAccessPolicy() {
  function canAccessTrash({ boxPolicy }: { boxPolicy: BoxAccessPolicy }) {
    return boxPolicy?.canAccessTrash ?? false
  }

  function canAddFilesRoot({ boxPolicy }: { boxPolicy: BoxAccessPolicy }) {
    return boxPolicy?.canAddFilesRoot ?? false
  }

  function canAddQueue({ boxPolicy }: { boxPolicy: BoxAccessPolicy }) {
    return boxPolicy?.canAddQueue ?? false
  }

  function canListFilesRoot({ boxPolicy }: { boxPolicy: BoxAccessPolicy }) {
    return boxPolicy?.canListFilesRoot ?? false
  }

  function canListQueue({ boxPolicy }: { boxPolicy: BoxAccessPolicy }) {
    return boxPolicy?.canListQueue ?? false
  }

  return {
    canAccessTrash,
    canAddFilesRoot,
    canAddQueue,
    canListFilesRoot,
    canListQueue,
  }
}
